var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"320px","height":"560px"}},[_c('pdf',{attrs:{"url":"https://ebook.t.educg.com/fileDownloadPDF.out?fid=64b8b173a2f25a13be7fa228","type":"canvas"}}),_c('pdf',{attrs:{"url":"https://ebook.t.educg.com/fileDownloadPDF.out?fid=64b8b173a2f25a13be7fa228","type":"svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }